import { render, staticRenderFns } from "./WaView.vue?vue&type=template&id=c1b92b2a"
import script from "./WaView.vue?vue&type=script&lang=js"
export * from "./WaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports